import React from "react";
import { Col, Row } from "react-bootstrap";
import PerformanceRevnue from "./PerformanceRevnue";
import TrendDuration from "./TrendDuration";
import PeakCheckInChart from "./PeakCheckInChart";
import { useTranslation } from "react-i18next";

const ProductPerformance = ({ data }) => {
  const { t } = useTranslation();

  const {
    revenueByRoomTypeAndDuration = {},
    checkInTimeTrendByDuration = {},
    peakCheckInTimes = {},
  } = data || {};

  return (
    <section className="Product_Performance p-3">
      <Row>
        <Col lg="6" md="6" sm="12" className="my-2">
          <div className="performaceCard p-3 shadow-sm">
            <div className="d-flex align-items-start mb-3">
              <span className="me-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#e91e63"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  data-lucide="dollar-sign"
                >
                  <line x1="12" x2="12" y1="2" y2="22"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              </span>
              <h5 className="m-0">
                {t("productPerformance.revenueByRoomTypeDuration")}
              </h5>
            </div>

            <p>{t("productPerformance.revenueDescription")}</p>

            <PerformanceRevnue data={revenueByRoomTypeAndDuration} />
          </div>
        </Col>

        <Col lg="6" md="6" sm="12" className="my-2">
          <div className="performaceCard p-3 shadow-sm">
            <div className="d-flex align-items-start mb-3">
              <span className="me-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#e91e63"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  data-lucide="clock"
                  class="lucide lucide-clock w-5 h-5 text-primary-pink mr-3 mt-1"
                >
                  <path d="M12 6v6l4 2"></path>
                  <circle cx="12" cy="12" r="10"></circle>
                </svg>
              </span>
              <h5 className="m-0">
                {t("productPerformance.checkInTrendByDuration")}
              </h5>
            </div>

            <p>{t("productPerformance.checkInDescription")}</p>
            {/* <TrendDuration /> */}

            <TrendDuration data={checkInTimeTrendByDuration} />
            <PeakCheckInChart data={peakCheckInTimes} />
            {/* <TrendDuration data={checkInTimeTrendByDurationMock} /> */}

          </div>
        </Col>
      </Row>
    </section>
  );
};

export default ProductPerformance;
